module.exports = __webpack_public_path__ + "img/productHSE_13.831eac38.png";